<!--
  Root shell. A skip link and the routed layout.

  The skip link is first in the DOM and only visible on focus. Without it every
  keyboard user tabs through the whole nav on every page before reaching content,
  which is invisible in a screenshot and obvious the first time someone tries it.
  Its target, `#main`, lives inside `MainLayoutComponent` -- always active, since
  every route nests under its `path: ''` -- not inside this component.
-->
<a
  href="#main"
  class="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-white"
>
  Skip to content
</a>

<router-outlet />
